import { render, staticRenderFns } from "./CreatePatientDialog.vue?vue&type=template&id=b3d26c80&"
import script from "./CreatePatientDialog.vue?vue&type=script&lang=ts&"
export * from "./CreatePatientDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports